<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="openid" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['openid']" placeholder="请输入openid"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="运营审批" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['operateAudit']" placeholder="请输入运营审批"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="运营审批人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['operateName']" placeholder="请输入运营审批人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="运营驳回原因" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['operateReason']" placeholder="请输入运营驳回原因"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="财务审批" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['financialAudit']" placeholder="请输入财务审批"></a-input>
            </a-form-item>
          </a-col>.
          <a-col :span="24">.
            <a-form-item label="财务审批人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['financialName']" placeholder="请输入财务审批人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="财务驳回原因" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['financialReason']" placeholder="请输入财务驳回原因"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="退款状态，0-申请退款，1-运营审核同意，2-运营审核驳回，3-财务审核通过，4-财务审核驳回，5-完成退款" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['status']" placeholder="请输入退款状态，0-申请退款，1-运营审核同意，2-运营审核驳回，3-财务审核通过，4-财务审核驳回，5-完成退款" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="支付id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['registerPayOrderId']" placeholder="请输入支付id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="默认微信支付" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['payTime']" placeholder="请输入默认微信支付"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'RegisterRefoundAuditForm',
    components: {
      JFormContainer,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/registerRefoundAudit/registerRefoundAudit/add",
          edit: "/registerRefoundAudit/registerRefoundAudit/edit",
          queryById: "/registerRefoundAudit/registerRefoundAudit/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'openid','operateAudit','operateName','operateReason','financialAudit','financialName','financialReason','status','registerPayOrderId','payTime'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            console.log("表单提交数据1",this.model,values)
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据2",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'openid','operateAudit','operateName','operateReason','financialAudit','financialName','financialReason','status','registerPayOrderId','payTime'))
      },
    }
  }
</script>